<div class="list-display-cell">
  <!-- Label -->
  <div class="list-label"
       *ngIf="label"
       [style.fontSize.px]="labelFontSize"
       [style.fontWeight]="labelFontWeight"
       [style.fontStyle]="labelFontStyle"
       [style.color]="labelColor">
    {{ label }}
  </div>

  <!-- List Items -->
  <div class="list-items" *ngIf="listItems.length > 0">
    <div class="list-item"
         *ngFor="let item of listItems; let i = index; trackBy: trackByIndex"
         [style.fontSize.px]="rowFontSize"
         [style.fontWeight]="rowFontWeight"
         [style.fontStyle]="rowFontStyle"
         [style.color]="rowColor"
         [style.marginBottom.px]="i < listItems.length - 1 ? rowSpacing : 0">
      {{ renderItem(item) }}
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="listItems.length === 0 && !isEditMode">
    <mat-icon>list</mat-icon>
    <span>{{ emptyMessage }}</span>
  </div>

  <!-- Edit Mode Placeholder -->
  <div class="edit-mode-placeholder" *ngIf="listItems.length === 0 && isEditMode">
    <mat-icon>format_list_bulleted</mat-icon>
    <span>List Display</span>
    <small *ngIf="!cell?.configuration?.listDisplayContextVariable">No context variable configured</small>
    <small *ngIf="cell?.configuration?.listDisplayContextVariable">Context: {{ cell.configuration.listDisplayContextVariable }}</small>
  </div>
</div>
